import { connect } from 'react-redux';
import { setPage } from '../actions/filter';
import ResourceList from '../components/resource-list';

const mapStateToProps = (state) => {
	return {
		filter: state.filter,
		staticHtml: state.posts.staticHtml,
		page: state.filter.page,
		items: state.posts.items,
		itemView: state.posts.itemView,
		isLoading: state.posts.isLoading,
		hasLoaded: state.posts.hasLoaded,
		totalPages: state.posts.totalPages
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		onClickPage: (n) => {
			let pageNumber = n.selected + 1;
			dispatch(setPage(pageNumber));
			$('body,html').animate({
				scrollTop: 0
			});
		}
	}
}

const ResourceListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(ResourceList)

export default ResourceListContainer



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/blog-grid/containers/resource-list.container.js